import React, { useState } from 'react'
import { GoHeartFill, GoHeart } from "react-icons/go";


const cardData = [
    {
        id: 1,
        type: "Home",
        image: "img/dogLogo.png",
        title: "Asha Arun's pet home boarding",
        distance: "4 KM",
        area: "Area, City",
        description: "Fursure Pet Insurance offers coverage for pets, and if you have a booking or policy and want to cover your pet, then you can book a pet insurance policy with us.",
        status: "Open",
        time: "09:30 am - 08:30 pm",
        price: "₹450",
        available: "Available today",
        features: ["Home Boarding", "Home Grooming", "Mobile Pet Grooming Van", "Dog Walking", "Pet Shop"]
    },
    {
        id: 2,
        type: "Shop",
        image: "img/dogLogo.png",
        title: "Bark & Bite Pet Shop",
        distance: "2 KM",
        area: "Sector 15, Noida",
        description: "We provide all pet supplies and grooming services at the best prices. We also offer pet insurance services. If you have a pet, then you can book a pet insurance policy with us.",
        status: "Closed",
        time: "09:00 am - 09:00 pm",
        price: "₹300",
        available: "Not available today",
        features: ["Home Boarding", "Home Grooming", "Mobile Pet Grooming Van", "Dog Walking", "Pet Shop"]
    }
];

const Wishlist = () => {

    const [favorites, setFavorites] = useState([]);

    const toggleFavorite = (id) => {
        setFavorites((prev) =>
            prev.includes(id) ? prev.filter((favId) => favId !== id) : [...prev, id]
        );
    };
    return (
        <div>
            {cardData.map((card) => (
                <div
                    key={card.id}
                    className="card rounded-lg shadow-lg border border-[#FD590133] bg-white p-4 md:p-6 mb-6 relative cursor-pointer hover:scale-100 transition-all"

                >
                    {/* Heart Icon */}
                    <div
                        className="absolute top-4 right-4 cursor-pointer"
                        onClick={() => toggleFavorite(card.id)}
                    >
                        {favorites.includes(card.id) ? (
                            <GoHeartFill className="text-red-500 text-xl md:text-2xl" />
                        ) : (
                            <GoHeart className="text-gray-400 text-xl md:text-2xl" />
                        )}
                    </div>

                    <div className="flex flex-col md:flex-row justify-between gap-4">
                        {/* Left section */}
                        <div className="flex flex-col items-start">
                            <div className="bg-[#FFFAEB] flex p-2 md:p-3 rounded-md items-center gap-2">
                                <img src="img/home.png" alt="" className="w-5 md:w-auto" />
                                <p className="text-[#FF6216]">{card.type}</p>
                            </div>
                            <div>
                                <img src={card.image} alt="" className="w-32 h-32 md:w-44 md:h-44 object-contain" />
                            </div>
                        </div>

                        {/* Middle section */}
                        <div className="max-w-full md:max-w-[50%]">
                            <p className="text-[#000048] text-xl md:text-[32px] font-medium">{card.title}</p>
                            <p className="text-[#000048] mt-3">{card.distance}</p>
                            <p className="text-[#000048]">{card.area}</p>
                            <p className="text-[#000048] text-sm md:text-base">{card.description}</p>

                            <p
                                className={`text-lg md:text-xl flex items-center mt-3 md:mt-5 gap-3 md:gap-5 ${card.status === "Open" ? "text-[#39C408]" : "text-red-500"
                                    }`}
                            >
                                {card.status}
                                <span className="text-[#1B4582] font-medium">⦁ {card.time}</span>
                            </p>
                        </div>

                        {/* Right section */}
                        <div>
                            <p className="text-[#000048] text-sm md:text-[18px]">From</p>
                            <p className="text-[#000048] text-2xl md:text-[38px] font-semibold">{card.price}</p>
                            <div className="flex items-center gap-4 md:gap-6 mt-4 md:mt-16">
                                <img src="img/calendar.png" alt="" className="w-5 md:w-auto" />
                                <p className={card.available.includes("Not") ? "text-red-500" : "text-[#39C408]"}>
                                    {card.available}
                                </p>
                            </div>
                        </div>
                    </div>

                    {/* Features */}
                    <div className="flex flex-wrap gap-3 pt-4">
                        {card.features.map((feature) => (
                            <p
                                className="p-2 rounded-md text-[#000048] border border-[#FD590133] text-sm"
                                key={feature}
                            >
                                {feature}
                            </p>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    )
}

export default Wishlist